export default "__VITE_ASSET__DGMCzY5H__"